import React from 'react';
import PropTypes from 'prop-types';
import { PlusOutlined } from '@ant-design/icons';
import { Table, Button } from 'antd';
import { communicationStatus, platformEntity, entityAction } from '~constants';
import showElementByAuth from '~helpers/auth';
import NewSearch from 'common/components/new-search';
export default class TableList extends React.Component {
  constructor() {
    super();

    this.entityMapping = {
      city: platformEntity.LOCATIONS_CITIES,
      university: platformEntity.UNIVERSITIES_UNIVERSITIES,
    };
  }

  render() {
    const { t, filters, handleColumnsFilter } = this.props;

    const rankingTypes = [
      {
        label: t('cms.location.table.filter.ranking_type.option.label.star_cn'),
        value: 'starCn',
      },
      {
        label: t('cms.location.table.filter.ranking_type.option.label.star_row'),
        value: 'starRow',
      },
    ];

    return (
      <div className="table-list">
        <div className="table-header">
          <div className="table-header__container">
            <div className="table-header__heading-container">
              <div className="table-header__container--left">
                <h1 className="table-header__heading">
                  {t(`cms.location.table.num_${this.props.type}`, { num: this.props.list.total })}
                </h1>
                <If condition={this.props.type === 'city'}>
                  <NewSearch
                    key="rankingType"
                    options={rankingTypes}
                    onChange={items => {
                      handleColumnsFilter({
                        starCn: items.includes('starCn') ? true : null,
                        starRow: items.includes('starRow') ? true : null,
                      });
                    }}
                    placeholderInfo={{
                      title: this.props.t('cms:properties_ranking_type_title'),
                      filteredTitle: this.props.t('cms:properties_ranking_type_title'),
                    }}
                    defaultCheckedFilters={[
                      filters.starCn ? 'starCn' : null,
                      filters.starRow ? 'starRow' : null,
                    ].filter(e => e)}
                    type="noBorder"
                    noSearch
                  />
                </If>
              </div>
            </div>

            <If
              condition={showElementByAuth(
                this.entityMapping[this.props.type],
                entityAction.CREATE,
              )}
            >
              <div className="table-header__button-container">
                <Button onClick={this.props.onAddNewBtn}>
                  <PlusOutlined className="table-list__icon-plus" />
                  {t(`cms.location.table.add_new_${this.props.type}.button`)}
                </Button>
              </div>
            </If>
          </div>
        </div>
        <div className="table-list__wrapper">
          <Table
            rowKey="id"
            scroll={{ x: '0' }}
            className="table-list"
            columns={this.props.tableColumns}
            dataSource={this.props.list.payload}
            onChange={this.props.handleTableChange}
            loading={this.props.communication.list.status === communicationStatus.FETCHING}
            pagination={{
              current: this.props.filters.pageNumber,
              pageSize: this.props.filters.pageSize,
              showSizeChanger: true,
              hideOnSinglePage: false,
              total: this.props.list.total,
            }}
          />
        </div>
      </div>
    );
  }
}

TableList.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
  list: PropTypes.object,
  handleTableChange: PropTypes.func,
  handleColumnsFilter: PropTypes.func,
  communication: PropTypes.object,
  filters: PropTypes.object,
  onAddNewBtn: PropTypes.func,
  tableColumns: PropTypes.array,
};

TableList.defaultProps = {
  t: () => {},
  type: '',
  list: {},
  handleTableChange: () => {},
  handleColumnsFilter: () => {},
  communication: {},
  filters: {},
  onAddNewBtn: () => {},
  tableColumns: [],
};
